import { render, staticRenderFns } from "./snb-service-coterm.vue?vue&type=template&id=2e193593&scoped=true&"
import script from "./snb-service-coterm.vue?vue&type=script&lang=tsx&"
export * from "./snb-service-coterm.vue?vue&type=script&lang=tsx&"
import style0 from "./snb-service-coterm.vue?vue&type=style&index=0&id=2e193593&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e193593",
  null
  
)

export default component.exports